import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCollapseAll } from '../store/selectors';

export function useIsCollapsed(defaultCollapsed = true): [boolean, (value: boolean) => void] {
    const collapseAll = useSelector(selectCollapseAll);
    const [isCollapsed, setIsCollapsed] = useState(collapseAll || defaultCollapsed);

    /**
     * When collapseAll state changes, collapse/expand the section
     */
    useEffect(() => {
        if (collapseAll !== undefined) {
            setIsCollapsed(collapseAll);
        }
    }, [collapseAll]);

    return [isCollapsed, setIsCollapsed];
}
